import dynamic from 'next/dynamic';
import Head from 'next/head';

import HousePricesDetailInfo from './components/housePricesDetailInfo';
import HousePricesDetailLinks from './components/housePricesDetailLinks';
import HousePricesSimilarListing from './components/housePricesSimilarListing';
import HousePricesStat from './components/housePricesStat';
import useHPIDetail from './hooks/useHPIDetail';
import HousePricesDetailMap from './components/housePricesDetailMap';
import Maybe from '../../elements/maybe';

const HousePricesTrends = dynamic(import('./components/housePricesTrends'), {
  ssr: false,
});

const HousePricesDetailModule = () => {
  const { seo, marketStat, decode } = useHPIDetail({ city: undefined, region: undefined });
  const { title, description } = { ...seo?.seo };
  const staticMarketStat = marketStat?.stats.filter((s) => s.fixedPeriod);
  const [firstStat, restOfStat] = [
    staticMarketStat?.slice(0, 1)[0],
    staticMarketStat?.slice(1),
  ];


  return (
    <>
      <Head>
        <title>{title ? `${title}| کیلید  ` : decode?.seo.title}</title>
        <meta name='description' content={description} />
      </Head>
      <div className='container grid grid-cols-4 gap-4 py-12 lg:grid-cols-12 lg:gap-8 lg:py-20'>
        <div className='flex flex-col col-span-4 gap-16 lg:col-span-8 lg:gap-24'>
          <HousePricesDetailInfo />
          {firstStat && <HousePricesStat marketStat={firstStat} />}
          {marketStat?.trends && (
            <HousePricesTrends id={undefined} type={undefined} />
          )}
          {restOfStat &&
          restOfStat.map((stat) => (
            <HousePricesStat key={stat.title} marketStat={stat} />
          ))}
        </div>
        <div className='relative block col-span-4 pb-4'>
          <Maybe condition={true}>
            <HousePricesDetailMap />
          </Maybe>
          <HousePricesDetailLinks />
        </div>
        <div className='pb-4 col-span-full'>
          <HousePricesSimilarListing />

        </div>
      </div>
    </>
  );
};

export default HousePricesDetailModule;
